import { reducer } from './reducer';
import { sagas } from './sagas';


export const state = {
    reducer: {
        environment: reducer,
    },
    sagas,
};
